import axios from 'axios'
import store from '@/store'
import {toast} from "../class/Notification";


export default {
    namespaced: true,
    state: {
        files: {},
        directories: {},
        uploadPercent: -1,
        cacelToken: axios.CancelToken.source(),
        meta: {},
    },
    mutations: {
        setFiles(state, files) {
            state.files = files
        },
        setDirectories(state, directories) {
            state.directories = directories
        },
        setMeta(state, meta) {
            state.meta = meta
        },
        setUploadPercent(state, percent) {
            state.uploadPercent = percent
        },
    },
    actions: {
        setDirectories({commit}) {
            axios.get(`file-manager`)
                .then(res => {
                    const directories = res.data.data
                    commit('setDirectories', directories)
                })
                .catch(error => {
                    console.log(error)
                })
        },
        createDirectory({commit, state}, form) {
            axios.post(`file-manager/create/directory`, form)
                .then(res => {
                    state.directories.push(form.name)
                    toast('عملیات با موفقیت ایجاد شد', 'پوشه با موفقیت ایجاد شد')
                    commit('setFiles', state.directories)
                })
                .catch(error => {
                    console.log(error)
                })
        },
        directoryFiles({commit, state}, {directory, page = 1}) {
            axios.post(`file-manager/directory-content?page=${page}`, {directory: directory})
                .then(res => {
                    const response = res.data.data
                    commit('setFiles', response.data)
                    commit('setMeta', response.meta)
                })
                .catch(error => {
                    console.log(error)
                })
        },
        deleteFile({commit, state}, form) {
            axios.delete(`file-manager/${form.id}`)
                .then(res => {
                    // find index of file in files array base on id and remove it
                    const index = state.files.findIndex(file => file.id === form.id)
                    state.files.splice(index, 1)
                    commit('setFiles', state.files)
                })
                .catch(error => {
                    console.log(error)
                })
        },
        uploadFiles({commit, state}, form) {
            // change shape of the form and put files on FormData
            const formData = new FormData()
            formData.append('directory', form.uploadDirectory)
            // use loop to add files to FormData
            for (let i = 0; i < form.selectedFiles.length; i++) {
                formData.append(`files[${i}]`, form.selectedFiles[i])
            }
            let cancelTokenSource = axios.CancelToken.source();

            axios.post(`file-manager`, formData,
                {
                    headers: {'Content-Type': 'multipart/form-data'},
                    onUploadProgress: (progressEvent) => {
                        if (progressEvent.lengthComputable) {
                            this.percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                            store.commit('FileManager/setUploadPercent', this.percentCompleted)
                            if (this.percentCompleted == 100) {
                                store.commit('FileManager/setUploadPercent', -1)
                            }
                        }
                    },
                    cancelToken: store.state.FileManager.cacelToken.token
                })
                .then(res => {
                    document.querySelector('#upload-file___BV_modal_header_ > button').click()
                    store.dispatch('FileManager/directoryFiles', {directory: form.uploadDirectory})
                    toast('عملیات با موفقیت انجام شد', 'فایل با موفقیت آپلود شد')
                })
                .catch(error => {
                    console.log(error)
                })

        },
        cancelUpload({commit, state}) {
            state.cacelToken.cancel()
            toast('آپلود لغو شد', 'آپلود با موفقیت لغو شد', 'success')
        }
    },
    getters: {
        getFiles: state => state.files,
        getDirectories: state => state.directories,
        getPagination: state => state.meta,
        getUploadPercent: state => state.uploadPercent,
    },
}